export const COMPLIMENTARY_REASON = {
	THRESHOLD: 'threshold',
	BANK_TRANSFER: 'bank_transfer'
}

export const getComplimentaryReason = (item) =>
	item?.gift_reason === COMPLIMENTARY_REASON.BANK_TRANSFER
		? COMPLIMENTARY_REASON.BANK_TRANSFER
		: COMPLIMENTARY_REASON.THRESHOLD

export const getComplimentaryProductForReason = (cart, reason) =>
	(cart || []).find(
		(item) =>
			item.product_type === 'freeProduct' &&
			getComplimentaryReason(item) === reason
	)


export const getConfiguredGiftVariant = (item) => {
    const sizeId = item?.groesse?.strapi_id
    const variants = item?.produkt?.Variante
    if (sizeId == null || !Array.isArray(variants)) return undefined
    return variants.find((variant) =>
        variant?.groesse?.strapi_id != null &&
        String(variant.groesse.strapi_id) === String(sizeId)
    )
}

export const getComplimentaryStockCount = (items) =>
    (Array.isArray(items) ? items : []).reduce((total, item) => {
        const stock = Number(getConfiguredGiftVariant(item)?.Vorratsanzahl || 0)
        return total + (Number.isFinite(stock) ? Math.max(0, stock) : 0)
    }, 0)


export const getAvailableUpSalesProducts = (items, cart) => {
    const inCart = new Set((cart || []).map((item) => String(item.product_strapi_id)))
    return (Array.isArray(items) ? items : []).flatMap((item) => {
        const variant = getConfiguredGiftVariant(item)
        const stock = Number(variant?.Vorratsanzahl || 0)
        if (!variant || !Number.isFinite(stock) || stock <= 0 ||
            inCart.has(String(item.produkt.strapi_id))) return []
        return [{ ...item, Variante: variant }]
    })
}
